const validateString = (name, errorsObj) => {
	if (!name) {
		return errorsObj.empty;
	}
	if (name.length < 3) {
		return errorsObj.minLength;
	}
	if (name.length > 50) {
		return errorsObj.maxLength;
	}
};

const validateUniqueString = (newListName, previousListArr, errorStr) => {
	if (previousListArr.indexOf(newListName) !== -1) {
		return errorStr;
	}
};

export const validateWishlistName = (name, savedLists, newLists, lid) => {
	const validateStringVar = validateString(name, {
		empty: "Must provide a list name",
		minLength: "Name must be longer than 3 characters",
		maxLength: "Name must be less than 50 characters long",
	});

	let listNames;
	if (lid !== undefined) {
		listNames = Object.values(savedLists)
			.filter(list => list.lid !== lid)
			.map(list => list.lname);
	} else {
		listNames = Object.values(savedLists).map(list => list.lname);
	}
	listNames.push(...newLists.filter(list => list.id !== lid).map(list => list.name));

	const validateUniqueStringVar = validateUniqueString(
		name,
		listNames,
		"List name already exists",
	);

	return validateStringVar || validateUniqueStringVar;
};